import { connect } from 'react-redux';
import Dashboard from 'components/dashboard/Dashboard';
import { updateDashboard } from '../../actions/partner';

const mapStateToProps = (state) => {
  return {
    data: state.dashboard,
    meta: state.meta.dashboard,
  }
}

const DashboardContainer = connect(
  mapStateToProps,
  { updateDashboard }
)(Dashboard)

export default DashboardContainer;
